module.exports = __webpack_public_path__ + "static/media/shutterstock_1224288865.d98a7000.jpg";